module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.className
  }, [_c('button', {
    on: {
      "click": _vm.toggleRecordingStartStop
    }
  }, [_vm._v(_vm._s(_vm.buttonText))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-cef50480!./src/components/recorder/recorder.html
// module id = 117
// module chunks = 2